module.exports = __webpack_public_path__ + "img/Weapon_191.4e87782d.png";